import React from 'react';
import PropTypes from 'prop-types';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import { Wrap, Image, Header, Description } from './styled';

const EmptyCart = ({ className }) => (
    <Wrap className={className}>
        <Image alt="empty" />
        <Header>
            <Translator tk="CART_OVERLAY_EMPTY_HEADER" />
        </Header>
        <Description>
            <Translator tk="CART_OVERLAY_EMPTY_TEXT" />
        </Description>
    </Wrap>
);

EmptyCart.propTypes = {
    className: PropTypes.string,
};

EmptyCart.defaultProps = {
    className: '',
};

export default EmptyCart;
